module.exports = __webpack_public_path__ + "media/src/images/about/outline/capture_drawwwers_half-75fc7f1abba414671f653abc06d61a38.jpg";